import React from 'react';

export default function Messages() {
  return (
    <div className="messages">
      <h2>Messages</h2>
      <p>Message management will be implemented here.</p>
    </div>
  );
} 